import { Named } from '../base/named';
import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';

@Metamodel.model({
    name: 'column-flatten-settings'
})
export class ColumnFlattenSettings extends Named {
    public static readonly MODEL: IModel;
    public static readonly TREAT_ARRAY_AS_STRING: IAttribute;
    public static readonly TREAT_STRUCT_AS_STRING: IAttribute;
    public static readonly FLATTEN_COLUMN_DELIMITER: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ColumnMapping_TreatArrayAsString,
        templatable: true,
        association: 'TREAT_ARRAY_AS_STRING'
    })
    public treatArrayAsString: boolean = false;

    @Metamodel.attribute({
        display: stringResources.ColumnMapping_TreatStructAsString,
        templatable: true,
        association: 'TREAT_STRUCT_AS_STRING'
    })
    public treatStructAsString: boolean = false;

    @Metamodel.attribute({
        display: stringResources.ColumnMapping_FlattenColumnDelimiter,
        templatable: true,
        association: 'FLATTEN_COLUMN_DELIMITER'
    })
    public flattenColumnDelimiter: string = '.';
}
